import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SAJ_ROUTES } from '@libs/types/navigation';

import {
  LocationManagerExperienceConfig,
  LocationManagerExperienceService,
} from '../services';

@Injectable()
export class DefaultPageGuard {
  constructor(
    private lmExperienceService: LocationManagerExperienceService,
    private router: Router,
  ) {}

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.lmExperienceService.getExperience().pipe(
      map((config: LocationManagerExperienceConfig) => {
        if (config.isLocationManager) {
          return this.router.parseUrl(SAJ_ROUTES.Candidates);
        } else {
          return true;
        }
      }),
    );
  }
}
